import * as Yup from 'yup'
import dayjs from 'dayjs'

const isValidRoutingNumber = (routingNumber: string): boolean => {
  if (!/^\d{9}$/.test(routingNumber)) {
    return false
  }

  const digits = routingNumber.split('').map((digit) => {
    return parseInt(digit, 10)
  })

  const checksum =
    3 * (digits[0] + digits[3] + digits[6]) +
    7 * (digits[1] + digits[4] + digits[7]) +
    1 * (digits[2] + digits[5] + digits[8])

  return checksum % 10 === 0
}

Yup.addMethod(Yup.string, 'validateRoutingNumber', function (errorMessage) {
  return this.test('test-routing-number', errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return true
    }

    if (!isValidRoutingNumber(value)) {
      return createError({ path, message: errorMessage })
    }

    return true
  })
})

Yup.addMethod(Yup.string, 'validateExpirationDate', function (errorMessage) {
  return this.test(`test-expiration-date`, errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return createError({ path, message: errorMessage })
    }

    const cleanValue = value.replace(/undefined/g, '').replace(/--/g, '-')

    const date = dayjs(cleanValue, 'MM-YYYY', true)

    if (!date.isValid()) {
      return createError({ path, message: 'Date must be in MM-YYYY format' })
    }

    if (date.isBefore(dayjs(), 'month')) {
      return createError({ path, message: 'Expiration date cannot be in the past' })
    }

    return true
  })
})

export const BankInformationSchema = Yup.object().shape({
  routingNumber: Yup.string()
    .required('Routing number is required')
    // @ts-ignore
    .validateRoutingNumber('Routing number is invalid'),
  accountNumber: Yup.string().required('Account number is required'),
  accountType: Yup.string().required('Account type is required'),
})
